import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { Icon } from '../../_V2/assets';

// Mobile Footer
export function MobileFooter() {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        setUserInfo(parsedUserInfo?.userLogedIn);
      } catch {
        setUserInfo(null);
      }
    }
  }, []);

  const contactLink = userInfo ? "/help" : "/contactUs";
  const contactText = userInfo ? "Help" : "Contact Us";
  const howToPlay = userInfo ? "/how-to-play" : "/how-to-play";


  const handleHowToPlayClick = (e) => {
    e.preventDefault();
    const currentPath = window.location.pathname;

    if (currentPath === '/') {
      // We're on the landing page, scroll directly
      scrollToHowToPlay();
    } else {
      // Navigate to landing page with hash
      sessionStorage.setItem("landingVisited", "true");
      navigate(userInfo ? '/how-to-play' : '/how-to-play');
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const scrollToHowToPlay = () => {
    const elementId = 'howtoplay-mobile';
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="block tablet:hidden px-4 py-4">
      <div className="max-w-7xl mx-auto py-4">
        <div className="flex flex-col justify-center items-center gap-4">
          <div className="flex flex-col items-center gap-3 text-sm text-white/60 text-center">
            <div>
              <a href={howToPlay} className="hover:text-white transition-colors" onClick={handleHowToPlayClick}>
                How To Play
              </a>
            </div>
            <div><a href="/termsAndConditions" className="hover:text-white transition-colors">Terms & Conditions</a></div>
            <div><a href="/rules" className="hover:text-white transition-colors">Responsible Gaming</a></div>
            <div><a href="/privacyPolicy" className="hover:text-white transition-colors">Privacy & Cookie Policy</a></div>
            <div><a href={contactLink} className="hover:text-white transition-colors">{contactText}</a></div>
            <div><img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto block md:hidden" /></div>
          </div>
          <div className="text-sm font-medium text-white text-center">
            © Copyrights Reserved <span className="text-[#00C05B]">@SureShotSports FZ-LLC</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export function FooterTab({ componnent }) {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        setUserInfo(parsedUserInfo?.userLogedIn);
      } catch {
        setUserInfo(null);
      }
    }
  }, []);

  const contactLink = userInfo ? "/help" : "/contactUs";
  const contactText = userInfo ? "Help" : "Contact Us";
  const howToPlay = userInfo ? "/how-to-play" : "/how-to-play";

  const mtClass = componnent === "privacyPolicy"
    ? "tablet:mt-12"
    : componnent === "rules"
      ? "tablet:mt-28"
      : componnent === "termsAndConditions"
        ? "laptop:mt-36"
        : "";

  const handleHowToPlayClick = (e) => {
    sessionStorage.setItem("landingVisited", "true");
    e.preventDefault();
    const currentPath = window.location.pathname;

    if (currentPath === '/') {
      scrollToHowToPlay();
    } else {
      sessionStorage.setItem("landingVisited", "true");
      navigate(userInfo ? '/how-to-play' : '/how-to-play');
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const scrollToHowToPlay = () => {
    const isMobileView = window.innerWidth < 768;
    const elementId = isMobileView ? 'howtoplay-mobile' : 'howtoplay-desktop';
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className="px-4 md:px-6 w-full py-4">
      <div className="mx-auto py-4 -my-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 md:gap-0">
         <div className="text-sm md:text-base font-medium text-white text-center md:text-left">
              © Copyrights Reserved{" "}
              <span className="text-[#00C05B]">@SureShotSports FZ-LLC</span>
            </div>
          <div className="flex items-center gap-3 text-sm md:text-base text-white/60 flex-wrap justify-center">
            <div>
              <a
                href={howToPlay}
                className="hover:text-white transition-colors"
                // onClick={(e) => {
                //   e.preventDefault();
                //   const isMobileView = window.innerWidth < 768;
                //   const elementId = isMobileView
                //     ? "howtoplay-mobile"
                //     : "howtoplay-desktop";
                //   const element = document.getElementById(elementId);
                //   if (element) {
                //     element.scrollIntoView({
                //       behavior: "smooth",
                //       block: "start",
                //     });
                //   }
                //   window.history.pushState({}, "", "how-to-play");
                // }}
                // onClick={(e) => {
                //   e.preventDefault();
                //   if (userInfo) {
                //     navigate("/how-to-play");
                //   } else {
                //     const isMobileView = window.innerWidth < 768;
                //     const elementId = isMobileView
                //       ? "howtoplay-mobile"
                //       : "howtoplay-desktop";
                //     const element = document.getElementById(elementId);
                //     if (element) {
                //       element.scrollIntoView({
                //         behavior: "smooth",
                //         block: "start",
                //       });
                //     }
                //     window.history.pushState({}, "", "how-to-play");
                //   }
                // }}
                onClick={handleHowToPlayClick}
              >
                How To Play
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div>
              <a
                href="/termsAndConditions"
                className="hover:text-white transition-colors"
              >
                Terms & Conditions
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div>
              <a href="/rules" className="hover:text-white transition-colors">
                Responsible Gaming
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div>
              <a
                href="/privacyPolicy"
                className="hover:text-white transition-colors"
              >
                Privacy & Cookie Policy
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div className="flex items-center gap-2">
              <a
                href={contactLink}
                className="hover:text-white transition-colors"
              >
                {contactText}
              </a>
              <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto hidden md:block xl:hidden" />
            </div>
            <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto hidden lg:hidden xl:block" />
          </div>
        </div>
        <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto block md:hidden" />
      </div>
    </section>
  );
}

function Footer({ componnent }) {
  const navigate = useNavigate();

  const mtClass = componnent === "privacyPolicy"
    ? "tablet:mt-12"
    : componnent === "rules"
      ? "tablet:mt-28"
      : componnent === "termsAndConditions"
        ? "laptop:mt-36"
        : "";

  const handleHowToPlayClick = (e) => {
    e.preventDefault();
    sessionStorage.setItem("landingVisited", "true");
    const currentPath = window.location.pathname;

    if (currentPath === '/') {
      scrollToHowToPlay();
    } else {
      sessionStorage.setItem("landingVisited", "true");
      navigate('/how-to-play');
    }
  };

  const scrollToHowToPlay = () => {
    const isMobileView = window.innerWidth < 768;
    const elementId = isMobileView ? 'howtoplay-mobile' : 'howtoplay-desktop';
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };

  return (
    <section className={`hidden laptop:flex px-4 md:px-8 py-4 ${mtClass}`}>
      <div className="max-w-7xl mx-auto py-4 w-full">
        <div className="flex flex-row justify-between items-center gap-4">
          <div className="text-sm md:text-base font-medium text-white text-left">
            © Copyrights Reserved <span className="text-[#00C05B]">@SureShotSports FZ-LLC</span>
          </div>
          <div className="flex items-center gap-3 text-sm md:text-base text-white/60 flex-wrap justify-end">
            <div>
              <a href="/how-to-play" className="hover:text-white transition-colors" onClick={handleHowToPlayClick}>
                How To Play
              </a>
            </div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div><a href="/termsAndConditions" className="hover:text-white transition-colors">Terms & Conditions</a></div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div><a href="/rules" className="hover:text-white transition-colors">Responsible Gaming</a></div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div><a href="/privacyPolicy" className="hover:text-white transition-colors">Privacy & Cookie Policy</a></div>
            <div className="w-px h-4 bg-[#00C05B]"></div>
            <div><a href="/contactUs" className="hover:text-white transition-colors">Contact Us</a>
              <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto hidden md:block xl:hidden" />
            </div>
            <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto hidden lg:hidden xl:block" />
          </div>
        </div>
        <img src={Icon} alt="18+ Icon" className="w-6 h-6 mx-auto block md:hidden" />
      </div>
    </section>
  );
}

export default Footer;
